// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#out-overlay{position:absolute;z-index:10;top:0;width:50vw;height:100vh;transition:400ms}#out-overlay.focus-left{transform:translateX(0)}#out-overlay.focus-right{transform:translateX(50vw)}#out-overlay.standby{width:100vw;transform:translateX(0)}", ""]);
// Exports
module.exports = exports;
